import { useTranslation } from 'react-i18next';

export function FullPageLoader() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-3">
        <div className="border-brand-900 size-8 animate-spin rounded-full border-2 border-t-transparent" />
        <p className="text-ink-muted text-sm">{t('states.loading')}</p>
      </div>
    </div>
  );
}
